// import { dataDepConf, dateDpsendRequest } from '../config'
import request from '@/api/request'

/**
 * 获取用户登录信息
 */
// export const buriedPoint = (param) => {
//   const params = param
//   return dateDpsendRequest(dataDepConf.commonApi.buriedPoint, params)
// }

/**
 * 获取地区列表
 */
export const fetchAreaList = (data) => {
	return request({
		url: '/common/getAreas',
		method: 'post',
		data
	})
}
